// School classes index — dynamic behaviour
// Loaded via application.js; runs on turbolinks:load so it works
// regardless of which page the user lands on first.

$(document).on('turbolinks:load', function () {
  var dataEl = document.getElementById('school-classes-data');
  if (!dataEl) return;

  var user_role = dataEl.dataset.userRole;
  var testingCenterId = dataEl.dataset.testingCenterId ? parseInt(dataEl.dataset.testingCenterId, 10) : null;

  // Initialize custom dropdowns for this page
  const dropdownToggles = document.querySelectorAll('.custom-dropdown-toggle');
  const dropdownMenus = document.querySelectorAll('.custom-dropdown-menu');

  dropdownToggles.forEach(function (dropdownToggle) {
    const dropdownMenu = dropdownToggle.nextElementSibling;

    if (dropdownToggle && dropdownMenu) {
      dropdownToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Close all other dropdowns first
        dropdownMenus.forEach(function (menu) {
          if (menu !== dropdownMenu) {
            menu.style.display = 'none';
          }
        });

        const buttonRect = this.getBoundingClientRect();
        const dropdownHeight = dropdownMenu.offsetHeight || 150;
        const windowHeight = window.innerHeight;
        const spaceBelow = windowHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;

        if (dropdownMenu.style.display === 'none' || dropdownMenu.style.display === '') {
          dropdownMenu.style.position = 'fixed';
          dropdownMenu.style.zIndex = '999999';

          if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
            dropdownMenu.style.bottom = (windowHeight - buttonRect.top + 5) + 'px';
            dropdownMenu.style.top = 'auto';
          } else {
            dropdownMenu.style.top = (buttonRect.bottom + 5) + 'px';
            dropdownMenu.style.bottom = 'auto';
          }

          dropdownMenu.style.left = buttonRect.left + 'px';
          dropdownMenu.style.width = buttonRect.width + 'px';
          dropdownMenu.style.display = 'block';
          dropdownMenu.style.visibility = 'visible';
          dropdownMenu.style.opacity = '1';
          dropdownMenu.style.transform = 'none';
        } else {
          dropdownMenu.style.display = 'none';
        }
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!dropdownToggle.contains(e.target) && !dropdownMenu.contains(e.target)) {
          dropdownMenu.style.display = 'none';
        }
      });

      // Close dropdown when pressing Escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          dropdownMenu.style.display = 'none';
        }
      });

      // Close dropdown when clicking on dropdown items
      dropdownMenu.addEventListener('click', function (e) {
        if (e.target.classList.contains('custom-dropdown-item')) {
          dropdownMenu.style.display = 'none';
        }
      });
    }
  });

  // Initialize class list confirmation
  const confirmButton = document.getElementById('confirmButton');
  const checkbox = document.getElementById('class_list_confirmed');

  // Disable Confirm button by default
  if (confirmButton) {
    confirmButton.disabled = true;
  }

  // Add event listener to the checkbox
  if (checkbox && confirmButton) {
    checkbox.addEventListener('change', function () {
      confirmButton.disabled = !this.checked;
    });
    confirmButton.addEventListener('click', function () {
      if (testingCenterId) {
        fetch('/admin/testing_centers/' + testingCenterId + '/confirm_class_list', {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          }
        }).then(function (response) {
          if (response.ok) {
            window.location.reload();
          } else {
            alert('There was an error confirming the class list. Please try again.');
          }
        }).catch(function (error) {
          console.error('Error:', error);
          alert('There was an error confirming the class list. Please try again.');
        });
      }
    });
  }

  // Filter Sidebar Controls
  $('.filter-sidebar-trigger').off('click.scIndex').on('click.scIndex', function (e) {
    e.stopPropagation();
    $('#filter-sidebar').addClass('show');
    $('body').addClass('overflow-hidden');
  });

  $('.filter-sidebar-close, .filter-sidebar-overlay').off('click.scIndex').on('click.scIndex', function () {
    $('#filter-sidebar').removeClass('show');
    $('body').removeClass('overflow-hidden');
  });

  // Close sidebar when clicking outside
  $(document).off('click.scSidebar').on('click.scSidebar', function (e) {
    if ($('#filter-sidebar').hasClass('show')) {
      if (!$(e.target).closest('.filter-sidebar-content').length &&
          !$(e.target).closest('.filter-sidebar-trigger').length) {
        $('#filter-sidebar').removeClass('show');
        $('body').removeClass('overflow-hidden');
      }
    }
  });

  $(document).off('click.scSidebarContent').on('click.scSidebarContent', '.filter-sidebar-content', function (e) {
    e.stopPropagation();
  });

  // Clear individual filter
  $(document).off('click.scClearFilter').on('click.scClearFilter', '[data-clear-filter]', function (e) {
    e.preventDefault();
    var filterKey = $(this).data('clear-filter');
    var filterType = $(this).data('filter-type');
    var currentUrl = new URL(window.location);

    if (filterType === 'simple') {
      currentUrl.searchParams.delete(filterKey);
    } else {
      currentUrl.searchParams.delete('q[' + filterKey + ']');
    }

    window.location.href = currentUrl.toString();
  });

  // Close sidebar on Escape
  $(document).off('keydown.scIndex').on('keydown.scIndex', function (e) {
    if (e.keyCode === 27 && $('#filter-sidebar').hasClass('show')) {
      $('#filter-sidebar').removeClass('show');
      $('body').removeClass('overflow-hidden');
    }
  });

  // Table Sorting Controls
  $('.sort-asc, .sort-desc').off('click.scSort').on('click.scSort', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var sortField = $(this).data('sort');
    var sortDirection = $(this).data('direction');

    $('.table-header-custom th').removeClass('sorting-asc sorting-desc');
    $('.sort-icons i').removeClass('active');

    $(this).closest('th').addClass('sorting-' + sortDirection);
    $(this).addClass('active');

    var currentUrl = new URL(window.location);
    currentUrl.searchParams.set('sort', sortField);
    currentUrl.searchParams.set('direction', sortDirection);

    window.location.href = currentUrl.toString();
  });

  // Show active sort on page load
  var urlParams = new URLSearchParams(window.location.search);
  var currentSort = urlParams.get('sort');
  var currentDirection = urlParams.get('direction');

  if (currentSort && currentDirection) {
    $('[data-sort="' + currentSort + '"]').closest('th').addClass('sorting-' + currentDirection);
    $('[data-sort="' + currentSort + '"][data-direction="' + currentDirection + '"]').addClass('active');
  }
});

window.clearFilters = function () {
  $('#filter_form')[0].reset();
  $('.select2').val(null).trigger('change');
};
